import TeletelRolesAPI from '../../api/teletel/roles';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isSaving: false,
  },
};

export const getters = {
  getRoles: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async get({ commit }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await TeletelRolesAPI.get();
      commit('setRoles', data);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },
  async create({ commit }, role) {
    commit('setUIFlag', { isSaving: true });
    try {
      const { data } = await TeletelRolesAPI.create({ custom_role: role });
      commit('upsertRole', data);
      return data;
    } finally {
      commit('setUIFlag', { isSaving: false });
    }
  },
  async update({ commit }, { id, ...role }) {
    commit('setUIFlag', { isSaving: true });
    try {
      const { data } = await TeletelRolesAPI.update(id, { custom_role: role });
      commit('upsertRole', data);
      return data;
    } finally {
      commit('setUIFlag', { isSaving: false });
    }
  },
  async delete({ commit }, id) {
    await TeletelRolesAPI.delete(id);
    commit('removeRole', id);
  },
  async assign({ dispatch }, { userId, customRoleId }) {
    await TeletelRolesAPI.assign(userId, customRoleId);
    // Assigned-count changes server-side; refresh the list.
    await dispatch('get');
  },
};

export const mutations = {
  setUIFlag($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  setRoles($state, roles) {
    $state.records = roles;
  },
  upsertRole($state, role) {
    const index = $state.records.findIndex(r => r.id === role.id);
    if (index === -1) $state.records.push(role);
    else $state.records.splice(index, 1, role);
  },
  removeRole($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
